import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';

@Component({
  templateUrl: './loginView.component.html',
  styleUrls: ['./loginView.component.scss'],
})
export class LoginViewComponent implements OnInit {
  loginForm: FormGroup;

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.loginForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      rememberMe: new FormControl(true),
    });

    localStorage.removeItem('rememberMe');
  }

  onSubmit(e) {
    e.preventDefault();
    this.authService.login(
      this.loginForm.get('username').value,
      this.loginForm.get('password').value,
      this.loginForm.get('rememberMe').value,
    );
  }

  getMicrosoftAuthUrl() {
    const {
      MSAuthUrl,
      clientId,
      redirectUrl,
      responseType,
      resource,
    } = environment.microsoftAuth;

    return `${MSAuthUrl}?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=${responseType}&resource=${resource}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/views/loginView/loginView.component.ts